export default "__VITE_ASSET__95Nisza0__"